import { Database } from '@nozbe/watermelondb'
import { ComponentInfoChatVO } from '@repo/types'
import { Chat } from '../model'
import { findChatByConnectionKeyAndPhoneNumber } from '../readers'
import { createChat } from './createChat'

export const addChat = async (payload: ComponentInfoChatVO, database: Database): Promise<Chat> => {
  return database.write(async writer => {
    const chat = await writer.callReader(async () =>
      findChatByConnectionKeyAndPhoneNumber(payload.connectionKey, payload.phoneNumber, database)
    )
    if (!chat) {
      return await writer.callWriter(async () => createChat(payload, database))
    }
    return await writer.callWriter(async () => chat.updateChat(payload))
  })
}
